import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, signal, Signal } from '@angular/core';
import { Display } from 'app/interfaces/display.interface';
import { DisplaysService } from 'app/services/displays.service';
import { DisplaysListItemComponent } from '../displays-list-item/displays-list-item.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-displays-list',
  standalone: true,
  templateUrl: './displays-list.component.html',
  styleUrl: './displays-list.component.scss',
  imports: [CommonModule, DisplaysListItemComponent,TranslateModule]
})
export class DisplaysListComponent implements OnInit {

  @Input() displays: Signal<Display[]> = signal<Display[]>([]);
  @Input() loaded: Signal<boolean> = signal<boolean>(false);

  constructor(private displaysService: DisplaysService) {}

  public ngOnInit(): void {

  }
}
